(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  // Default to "In stock" only, but only once per session — otherwise a
  // customer who unchecks the filter to see sold-out items would get
  // force-redirected right back to it every time the param disappears.
  if (!url.searchParams.has('filter.v.availability') && !sessionStorage.getItem('defaultedAvailabilityFilter')) {
    sessionStorage.setItem('defaultedAvailabilityFilter', '1');
    url.searchParams.set('filter.v.availability', '1');
    window.location.replace(url.toString());
  }
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // Fills the sticky bar's compact "4x $62.00/mo" line from Shopify's own
  // official payment-terms data (shopify-meta on <shopify-payment-terms>,
  // set by the {{ form | payment_terms }} filter) -- the real per-term
  // amount and installment count it already calculated, just reformatted
  // shorter instead of showing its full sentence. The source widget stays
  // in the DOM (hidden) purely as the data source.
  document.querySelectorAll('[data-installments-source]').forEach(function (source) {
    var target = source.parentElement && source.parentElement.querySelector('[data-installments-compact]');
    if (!target) return;

    var widget = source.querySelector('shopify-payment-terms');
    if (!widget) return;

    function render() {
      var raw = widget.getAttribute('shopify-meta');
      if (!raw) return;
      var meta;
      try {
        meta = JSON.parse(raw);
      } catch (e) {
        return;
      }
      var variant = meta.variants && meta.variants[0];
      if (!variant || !variant.eligible || !variant.number_of_payment_terms) return;

      // price_per_term is a formatted string like "$62.00" -- round up to a
      // whole dollar (never understate what's owed) and drop the decimals.
      var match = /([^\d]*)([\d,]+)(?:\.\d+)?/.exec(variant.price_per_term);
      var displayPrice = variant.price_per_term;
      if (match) {
        var symbol = match[1];
        var wholeNumber = parseInt(match[2].replace(/,/g, ''), 10);
        var hasCents = variant.price_per_term.indexOf('.') !== -1;
        var rounded = hasCents ? wholeNumber + 1 : wholeNumber;
        displayPrice = symbol + rounded.toLocaleString('en-US');
      }

      target.textContent = variant.number_of_payment_terms + 'x ' + displayPrice + '/mo';
    }

    render();
    new MutationObserver(render).observe(widget, { attributes: true, attributeFilter: ['shopify-meta'] });
    // The button submits its own real cart form (return_to=/checkout) --
    // no click-forwarding JS needed here.
  });

  // Product view tracking for the smart-send email project -- only present
  // in the DOM when a logged-in customer is viewing this product.
  document.querySelectorAll('[data-product-view-tracker]').forEach(function (el) {
    fetch('https://kfihrjsgxwdvfkvduqdn.supabase.co/functions/v1/track-product-view', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId: el.dataset.customerId,
        productId: el.dataset.productId,
        productHandle: el.dataset.productHandle,
        productTitle: el.dataset.productTitle,
        imageUrl: el.dataset.imageUrl,
      }),
      keepalive: true,
    }).catch(function () {
      // Best-effort only -- a failed view log should never affect the
      // shopper's actual page experience.
    });
  });

  } catch(e) { console.error(e); }
})();
})();
